import React from 'react';
import { StyledTextAreaField } from './textAreaField.style';

const TextAreaField = (props) => {
  const { varient = 'normal', color = 'primary', sizevalue = 'big', ...otherProps } = props;

  return (
    <StyledTextAreaField sizevalue={sizevalue} varient={varient} color={color} {...otherProps} />
  );
};

export default TextAreaField;
